import { ShieldAlert, LogOut } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth";
import { useBranding } from "../lib/company";

/**
 * Shown while a platform admin is inside a tenant via Impersonate, so it is
 * never a mystery whose data is on screen — and there is one obvious way
 * back out (Jun 2026).
 *
 * Driven by the `impersonated_by` claim on the JWT (surfaced by
 * /auth/me), NOT by a browser flag: a flag survived sign-out and then
 * mislabelled the next person's normal session as an impersonation.
 */
export const ImpersonationBanner = () => {
  const { user, logout } = useAuth();
  const branding = useBranding();
  if (!user?.impersonated_by) return null;

  const company =
    branding?.brand_name || branding?.trading_name || user.tenant_slug || "this company";

  const exit = () => {
    logout();
    window.location.href = "/platform";
  };

  return (
    <div
      className="flex items-center gap-3 bg-amber-500 px-4 py-1.5 text-[13px] font-medium text-amber-950"
      data-testid="impersonation-banner"
    >
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Platform admin ({user.impersonated_by}) — viewing{" "}
        <strong>{company}</strong> as {user.email}. Changes you make are real.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="ml-auto h-7 border-amber-900/40 bg-amber-100 text-amber-950 hover:bg-white"
        onClick={exit}
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="mr-1.5 h-3.5 w-3.5" />
        Exit
      </Button>
    </div>
  );
};
